import TextField from "@mui/material/TextField";
import { appFormFieldSx } from "../../lib/ui/formLayout";
import { APP_FORM_DEFAULTS, type AppTextFieldProps } from "./constants";

/**
 * Standard MUI outlined TextField used across application screens.
 */
export default function AppTextField({ size, variant, fullWidth, margin, sx, ...rest }: AppTextFieldProps) {
  return (
    <TextField
      {...APP_FORM_DEFAULTS}
      size={size ?? APP_FORM_DEFAULTS.size}
      variant={variant ?? APP_FORM_DEFAULTS.variant}
      fullWidth={fullWidth ?? APP_FORM_DEFAULTS.fullWidth}
      margin={margin ?? APP_FORM_DEFAULTS.margin}
      sx={[appFormFieldSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...rest}
    />
  );
}
